import errorBoxHTML from "../errorBox.html";
import successBoxHTML from "../successBox.html"
import successBoxEscrow from "../successBoxEscrow.html"


$(document).ready(function () {
    /*--------------------------------------*/
    function receiveMessage(event) {
        var origin = event.origin || event.originalEvent.origin; // For Chrome, the origin property is in the event.originalEvent object.
        var theme_color = event.data.theme_color;
        $(".send-btn").css("background-color", theme_color);

        function injectStyles(rule) {
            $('<style>' + rule + '</style>').appendTo("body");
        }

        injectStyles('.mdl-textfield__label:after { background-color: ' + theme_color + '; }');
        injectStyles('.send-btn:hover { opacity: 0.9;');
    }

    window.addEventListener("message", receiveMessage, false);
    /*--------------------------------------*/


    var form_processing = false;
    let formElement = $("#offer-form");
    let formTemplate = $("body");

    var props = {};

    var match,
        pl = /\+/g,  // Regex for replacing addition symbol with a space
        search = /([^&=]+)=?([^&]*)/g,
        decode = function (s) {
            return decodeURIComponent(s.replace(pl, " "));
        },
        query = window.location.search.substring(1);
    while (match = search.exec(query))
        props[decode(match[1])] = decode(match[2]);

    //        fix size
    // var iframe = $('#' + props.id + ' #iframe', parent.document.body);
    // iframe.height($(document.body).height() + 20);
    window.parent.postMessage({
        height: $(document.body).height() + 20,
        type: 'fixSize',
        popupId: props.id
    }, "*");
    //////////////////////////////////////////////////////////

    if (props.domainName) formElement.find('#domain_for').val(props.domainName);
    props.domainName = props.domainName || "this domain";

    ['template_id', 'template_source'].forEach(paramName => {
        if (props[paramName]) {
            let formInput = formElement.find('#' + paramName);
            if (formInput) {
                formInput.val(props[paramName]);
            }
        }
    });
    if (props.minOfferAmount) {
        formElement.find('#form-price').val(props.minOfferAmount);
    }

    var requiredFields = $('.will_required');
    formTemplate.find("#submitButton").unbind().click((e) => {
        requiredFields.each(function () {
            $(this).prop('required', true);
        })
        formElement.submit();
    });


    //////////////////////////////////////////////////////////

    $('#offer-form').on('submit', function (e) {
        function initLoading() {
            form_processing = true;
            formElement.addClass("processing");
            formElement.find('.sendButton').addClass('disabled');
            $('.send_btn_text').css({display: "none"});
            $('.loading_icon').css({display: "inline"});
        }
        function endLoading() {
            form_processing = false;
            window.parent.postMessage(props.id, "*");
            formElement.removeClass("processing");
            formElement.find('.sendButton').removeClass('disabled');
        }
        if (form_processing) {
            return
        }
        if (Array.from(requiredFields).every(function (el) {
            return $(el).val() !== ""
        })) {
            initLoading();
            e.preventDefault();
            grecaptcha.ready(function() {
                grecaptcha.execute(process.env.g_sitekey, {action: 'popupform'}).then(function(token) {
                if (token) {
                    var data = formElement.serializeArray(); // convert form to array
                    data.push({name: "userId", value: props.userId});
                    data.push({name: "token", value: token});

                    $.ajax({
                        type: "POST",
                        url: process.env.apiEndPoint,
                        data: $.param(data),
                        success: function (data) {
                            var originalForm = formElement.detach();
                            $('.send_btn_text').css({display: "inline"});
                            $('.loading_icon').css({display: "none"});
                            if (data.escrow) {
                                formTemplate.html(successBoxEscrow);
                            } else {
                                formTemplate.html(successBoxHTML);
                            }
                        },
                        error: () => {
                            var originalForm = formElement.detach();
                            formTemplate.html(errorBoxHTML);
                            formTemplate.find("a.close").click(() => {
                                formTemplate.html(originalForm);
                            });
                        },
                        complete: endLoading
                    });
                } else {
                    endLoading();
                }
                });
            });
        } else {
            requiredFields.each(function () {
                if ($(this).val() === "") {
                    $(this).closest('.mdl-textfield').addClass('is-invalid');
                }
            })
        }
    });
});


/** WEBPACK FOOTER **
 ** ./src/iframes/js/form.js
 **/